<template>
    <div>
    <section class="main-section">
        <div class="main-section__container">
            <h1>Want to know if you can share a PR news story?</h1>
            <img src="../assets/images/pr-tree-main.svg" alt="">
        </div>
    </section>
    <section class="main-text">
        <div class="main-text__container">
            <p>Use our PR decision tree below to help you decide what to do when creating company PR. Click on the type of PR you have below to get started.</p>
            <div id="select-pr-type">
                <button id="pr-type-proactive" @click="showProactive">Proactive</button>
                <button id="pr-type-reactive" @click="showReactive">Reactive</button>
            </div>
        </div>
    </section>
    <QuestionsPro id="questions" v-if="showPro"/>
    <QuestionsReact id="questions" v-if="showReact"/>
    </div>
  </template>

<script>
import QuestionsPro from "./questions-pro.vue";
import QuestionsReact from "./questions-react.vue";

export default {
  name: "MainPage",
  components: {
    QuestionsPro,
    QuestionsReact,
    },
    data() {
        return {
            showPro: false,
            showReact: false,
            showButtons: true,
        };
    },
    methods: {
    async showProactive() {
        let maintext = document.getElementsByClassName('main-text');
        let buttons = document.getElementById('select-pr-type');
        maintext[0].classList.add('complete');
        buttons.style.display = 'none';
        this.showPro = !this.showPro;
        this.showButtons = !this.showButtons;
    },

    async showReactive() {
        let maintext = document.getElementsByClassName('main-text');
        let buttons = document.getElementById('select-pr-type');
        buttons.style.display = 'none';
        maintext[0].classList.add('complete');
        this.showButtons = false;
        this.showReact = !this.showReact;
    },
    
    // login() {
    //   this.$auth.signInWithRedirect()
    // },
  }
};


</script>

<style lang="scss">
$desktop: 1024px;
$tablet: 768px;
$mobile: 600px;

.main-section {
    background: #FAFAFA;
    margin: 0;
    padding: 0;

    &__container {
        max-width: 1062px;
        margin: 0 auto;
        padding: 57px 0 140px;
        text-align: center;
        position: relative;

        @media only screen and (min-width: 768px) {
            padding: 57px 0 290px;
        }

        @media only screen and (min-width: 992px) {
            padding: 57px 0 347px;
        }
    }

    h1 {
        color: #242E30;
        text-align: center;
        font-family: "JETSans-Black", "Open Sans", Helvetica, sans-serif;
        font-size: 28px;
        font-style: normal;
        font-weight: 800;
        line-height: 36px; /* 127.692% */
        margin: 0 auto 57px;
        max-widtH: 350px;
        padding: 0 15px;

        @media only screen and (min-width: 768px) {
            font-size: 65px;
            line-height: 83px; /* 127.692% */
            max-width: none;
        }
    }

    img {
        position: absolute;
        bottom: -37px;
        left: 50%;
        transform: translateX(-50%);
        max-width: 350px;
        width: 100%;
        padding: 0 15px;

        @media only screen and (min-width: 768px) {
            max-width: 650px;
        }
    }
}

.main-text {
    padding: 74px 0 100px;

    @media only screen and (min-width: 768px) {
        padding: 104px 0 130px;
    }

    &.complete {
        padding-bottom: 10px;

        @media only screen and (min-width: 768px) {
            padding-bottom: 65px;
        }
    }

    &__container {
        max-width: 964px;
        margin: 0 auto;

    }
    p {
        color: #242E30;
        text-align: center;
        font-family: "JETSans-regular";
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 140%; /* 35px */
        max-width: 350px;
        padding: 0 15px;
        margin: 0 auto 40px;

        @media only screen and (min-width: 768px) {
            font-size: 25px;
            max-width: none;
        }
    }

    #select-pr-type {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        max-width: 350px;
        margin: 0 auto;
        padding: 0 15px;

        @media only screen and (min-width: 768px) {
            max-width: 700px;
        }
    }

    button {
        display: inline-flex;
        padding: 23px 35px;
        justify-content: center;
        align-items: center;
        background: white;
        text-align: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 100%; /* 30px */
        border-radius: 43.091px;
        border: 2.585px solid var(--charcoal, #242E30);
        transition: all 0.25s ease-in-out;

        @media only screen and (min-width: 768px) {
            padding: 23px 69px;
            font-size: 30px;
        }

        &:hover {
                cursor: pointer;
                background: #EFEDEA;
            }
    }
}
</style>